import { render, staticRenderFns } from "./ModeratorQuestionBox.vue?vue&type=template&id=3d0b4de9&scoped=true"
import script from "./ModeratorQuestionBox.vue?vue&type=script&lang=js"
export * from "./ModeratorQuestionBox.vue?vue&type=script&lang=js"
import style0 from "./ModeratorQuestionBox.vue?vue&type=style&index=0&id=3d0b4de9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0b4de9",
  null
  
)

export default component.exports